/**
 * @generated SignedSource<<9a1cca5641304743b8ceee61eb9c13e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersUseSharingUrl$data = {
  readonly urlAlias: string;
  readonly " $fragmentType": "helpersUseSharingUrl";
};
export type helpersUseSharingUrl$key = {
  readonly " $data"?: helpersUseSharingUrl$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersUseSharingUrl">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersUseSharingUrl"
};

(node as any).hash = "85a27b308974b238dfaa52513f331c35";

export default node;
